const About = () => {
    return(
    <>
    <div>
        <h1>About Us</h1>
        <h2>This is a React project for food ordering app</h2>
    </div>
    </>
    );
}

export default About;